<template>
  <van-dialog
    getContainer="#HorizontalScreen"
    v-model="showTip"
    :title="tipstr"
    :before-close="beforeClose"
    :confirmButtonText='okText'
    :cancelButtonText='closeText'
    :message='messageText'
    :show-cancel-button="showCancelButton"
  >
  </van-dialog>
</template>
<script>
export default {
  name: "logintip",
  data() {
    return {
      showTip:this.show
    };
  },

  watch: {
    show(val) {
      this.showTip = val
    }
  },
  props: {
    showCancelButton: {
      type: Boolean,
      default: true,
    },
    tipstr: {
      type: String,
      default: "立即注册星妈会享受定制化育儿服务",
    },
    okText:{
      type: String,
      default: "确认",
    },
    closeText:{
      type: String,
      default: "取消",
    },
    messageText:{
      type: String,
      default: "",
    },
    show: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    beforeClose(action, done) {
      if (action === "confirm") {
        this.$emit("confirmWay");
        done();
      } else if (action === "cancel") {
        this.$emit("cancleWay");
        done();
      }
    },
  },
};
</script>
<style lang="less" scoped>
    /deep/ .van-dialog__confirm, .van-dialog__confirm:active{
      color: #D4A437;
    }
    /deep/ .van-dialog__message{
      color: #000;
      font-weight: 500;
      font-size: 16px;
    }
</style>
